export const PROJECT_REQUEST="autproject/make/request";
export const PROJECT_SUCCESS="project/request/success";
export const PROJECT_ERROR="project/request/error";
